const countryCode = [
  {
    code: 'IS',
    code3: 'ISL',
    name: 'アイスランド',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'IE',
    code3: 'IRL',
    name: 'アイルランド',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'AZ',
    code3: 'AZE',
    name: 'アゼルバイジャン',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'US',
    code3: 'USA',
    name: 'アメリカ合衆国',
    area_code: 'ame',
    flag: 1,
    display: 1,
  },
  {
    code: 'AS',
    code3: 'ASM',
    name: 'アメリカ領サモア',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'VI',
    code3: 'VIR',
    name: 'アメリカ領ヴァージン諸島',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'AE',
    code3: 'ARE',
    name: 'アラブ首長国連邦',
    area_code: 'afr',
    flag: 1,
    display: 1,
  },
  {
    code: 'AR',
    code3: 'ARG',
    name: 'アルゼンチン',
    area_code: 'sam',
    flag: 1,
    display: 2,
  },
  {
    code: 'AW',
    code3: 'ABW',
    name: 'アルバ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'AL',
    code3: 'ALB',
    name: 'アルバニア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'AM',
    code3: 'ARM',
    name: 'アルメニア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'AI',
    code3: 'AIA',
    name: 'アンギラ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'AO',
    code3: 'AGO',
    name: 'アンゴラ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'AG',
    code3: 'ATG',
    name: 'アンティグア・バーブーダ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'AN',
    code3: 'ANT',
    name: 'アンティル列島',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'GB',
    code3: 'GBR',
    name: 'イギリス',
    area_code: 'eur',
    flag: 1,
    display: 1,
  },
  {
    code: 'VG',
    code3: 'VGB',
    name: 'イギリス領ヴァージン諸島',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'IL',
    code3: 'ISR',
    name: 'イスラエル',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'IT',
    code3: 'ITA',
    name: 'イタリア',
    area_code: 'eur',
    flag: 1,
    display: 4,
  },
  {
    code: 'IR',
    code3: 'IRN',
    name: 'イラン',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'IN',
    code3: 'IND',
    name: 'インド',
    area_code: 'asi',
    flag: 1,
    display: 9,
  },
  {
    code: 'ID',
    code3: 'IDN',
    name: 'インドネシア',
    area_code: 'asi',
    flag: 1,
    display: 10,
  },
  {
    code: 'WF',
    code3: 'WLF',
    name: 'ウォリス・フツナ',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'UG',
    code3: 'UGA',
    name: 'ウガンダ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'UA',
    code3: 'UKR',
    name: 'ウクライナ',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'UZ',
    code3: 'UZB',
    name: 'ウズベキスタン',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'UY',
    code3: 'URY',
    name: 'ウルグアイ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'EC',
    code3: 'ECU',
    name: 'エクアドル',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'EG',
    code3: 'EGY',
    name: 'エジプト',
    area_code: 'afr',
    flag: 1,
    display: 3,
  },
  {
    code: 'EE',
    code3: 'EST',
    name: 'エストニア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'ET',
    code3: 'ETH',
    name: 'エチオピア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'ER',
    code3: 'ERI',
    name: 'エリトリア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'SV',
    code3: 'SLV',
    name: 'エルサルバドル',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'OM',
    code3: 'OMN',
    name: 'オマーン',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'NL',
    code3: 'NLD',
    name: 'オランダ',
    area_code: 'eur',
    flag: 1,
    display: 6,
  },
  {
    code: 'SX',
    code3: 'SXM',
    name: 'オランダ領シント・マールテン',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'AU',
    code3: 'AUS',
    name: 'オーストラリア',
    area_code: 'oce',
    flag: 1,
    display: 1,
  },
  {
    code: 'AT',
    code3: 'AUT',
    name: 'オーストリア',
    area_code: 'eur',
    flag: 1,
    display: 8,
  },
  {
    code: 'KZ',
    code3: 'KAZ',
    name: 'カザフスタン',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'QA',
    code3: 'QAT',
    name: 'カタール',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'CA',
    code3: 'CAN',
    name: 'カナダ',
    area_code: 'ame',
    flag: 1,
    display: 2,
  },
  {
    code: 'CM',
    code3: 'CMR',
    name: 'カメルーン',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'KH',
    code3: 'KHM',
    name: 'カンボジア',
    area_code: 'asi',
    flag: 1,
    display: 13,
  },
  {
    code: 'CV',
    code3: 'CPV',
    name: 'カーボベルデ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'GY',
    code3: 'GUY',
    name: 'ガイアナ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'GA',
    code3: 'GAB',
    name: 'ガボン',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'GH',
    code3: 'GHA',
    name: 'ガーナ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'CY',
    code3: 'CYP',
    name: 'キプロス',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'CU',
    code3: 'CUB',
    name: 'キューバ',
    area_code: 'sam',
    flag: 1,
    display: 6,
  },
  {
    code: 'KI',
    code3: 'KIR',
    name: 'キリバス',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'KG',
    code3: 'KGZ',
    name: 'キルギス',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'GN',
    code3: 'GIN',
    name: 'ギニア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'GR',
    code3: 'GRC',
    name: 'ギリシャ',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'KW',
    code3: 'KWT',
    name: 'クウェート',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'CK',
    code3: 'COK',
    name: 'クック諸島',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'HR',
    code3: 'HRV',
    name: 'クロアチア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'GT',
    code3: 'GTM',
    name: 'グアテマラ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'GP',
    code3: 'GLP',
    name: 'グアドループ島',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'GU',
    code3: 'GUM',
    name: 'グアム',
    area_code: 'mic',
    flag: 1,
    display: 1,
  },
  {
    code: 'GL',
    code3: 'GRL',
    name: 'グリーンランド',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'GE',
    code3: 'GEO',
    name: 'グルジア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'GD',
    code3: 'GRD',
    name: 'グレナダ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'KY',
    code3: 'CYM',
    name: 'ケイマン諸島',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'KE',
    code3: 'KEN',
    name: 'ケニア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'CR',
    code3: 'CRI',
    name: 'コスタリカ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'KM',
    code3: 'COM',
    name: 'コモロ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'CO',
    code3: 'COL',
    name: 'コロンビア',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'CI',
    code3: 'CIV',
    name: 'コートジボワール',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'SA',
    code3: 'SAU',
    name: 'サウジアラビア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'WS',
    code3: 'WSM',
    name: 'サモア',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'ST',
    code3: 'STP',
    name: 'サントメ・プリンシペ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'ZM',
    code3: 'ZMB',
    name: 'ザンビア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'SL',
    code3: 'SLE',
    name: 'シエラレオネ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'SG',
    code3: 'SGP',
    name: 'シンガポール',
    area_code: 'asi',
    flag: 1,
    display: 7,
  },
  {
    code: 'DJ',
    code3: 'DJI',
    name: 'ジブチ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'GI',
    code3: 'GIB',
    name: 'ジブラルタル',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'JM',
    code3: 'JAM',
    name: 'ジャマイカ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'ZW',
    code3: 'ZWE',
    name: 'ジンバブエ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'CH',
    code3: 'CHE',
    name: 'スイス',
    area_code: 'eur',
    flag: 1,
    display: 7,
  },
  {
    code: 'SE',
    code3: 'SWE',
    name: 'スウェーデン',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'ES',
    code3: 'ESP',
    name: 'スペイン',
    area_code: 'eur',
    flag: 1,
    display: 5,
  },
  {
    code: 'SR',
    code3: 'SUR',
    name: 'スリナム',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'LK',
    code3: 'LKA',
    name: 'スリランカ',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'SK',
    code3: 'SVK',
    name: 'スロバキア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'SI',
    code3: 'SVN',
    name: 'スロベニア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'SZ',
    code3: 'SWZ',
    name: 'スワジランド',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'SN',
    code3: 'SEN',
    name: 'セネガル',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'RS',
    code3: 'SRB',
    name: 'セルビア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'KN',
    code3: 'KNA',
    name: 'セントクリストファー・ネイビス',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'VC',
    code3: 'VCT',
    name: 'セントビンセント・グレナディーン諸島',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'LC',
    code3: 'LCA',
    name: 'セントルシア',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'SC',
    code3: 'SYC',
    name: 'セーシェル',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'SB',
    code3: 'SLB',
    name: 'ソロモン諸島',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'TH',
    code3: 'THA',
    name: 'タイ',
    area_code: 'asi',
    flag: 1,
    display: 6,
  },
  {
    code: 'TJ',
    code3: 'TJK',
    name: 'タジキスタン',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'TZ',
    code3: 'TZA',
    name: 'タンザニア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'TC',
    code3: 'TCA',
    name: 'タークス・カイコス諸島',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'CZ',
    code3: 'CZE',
    name: 'チェコ',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'TN',
    code3: 'TUN',
    name: 'チュニジア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'CL',
    code3: 'CHL',
    name: 'チリ',
    area_code: 'sam',
    flag: 1,
    display: 3,
  },
  {
    code: 'TV',
    code3: 'TUV',
    name: 'ツバル',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'DK',
    code3: 'DNK',
    name: 'デンマーク',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'TT',
    code3: 'TTO',
    name: 'トリニダード・トバゴ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'TM',
    code3: 'TKM',
    name: 'トルクメニスタン',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'TR',
    code3: 'TUR',
    name: 'トルコ',
    area_code: 'afr',
    flag: 1,
    display: 2,
  },
  {
    code: 'TO',
    code3: 'TON',
    name: 'トンガ',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'TG',
    code3: 'TGO',
    name: 'トーゴ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'DE',
    code3: 'DEU',
    name: 'ドイツ',
    area_code: 'eur',
    flag: 1,
    display: 3,
  },
  {
    code: 'DO',
    code3: 'DOM',
    name: 'ドミニカ共和国',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'DM',
    code3: 'DMA',
    name: 'ドミニカ国',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'NG',
    code3: 'NGA',
    name: 'ナイジェリア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'NR',
    code3: 'NRU',
    name: 'ナウル',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'NA',
    code3: 'NAM',
    name: 'ナミビア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'NI',
    code3: 'NIC',
    name: 'ニカラグア',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'NC',
    code3: 'NCL',
    name: 'ニューカレドニア',
    area_code: 'oce',
    flag: 1,
    display: 5,
  },
  {
    code: 'NZ',
    code3: 'NZL',
    name: 'ニュージーランド',
    area_code: 'oce',
    flag: 1,
    display: 2,
  },
  {
    code: 'NP',
    code3: 'NPL',
    name: 'ネパール',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'NO',
    code3: 'NOR',
    name: 'ノルウェー',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'HT',
    code3: 'HTI',
    name: 'ハイチ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'HW',
    code3: 'HWI',
    name: 'ハワイ',
    area_code: 'hwi',
    flag: 1,
    display: 1,
  },
  {
    code: 'HU',
    code3: 'HUN',
    name: 'ハンガリー',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'VU',
    code3: 'VUT',
    name: 'バヌアツ',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'BS',
    code3: 'BHS',
    name: 'バハマ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'BM',
    code3: 'BMU',
    name: 'バミューダ諸島',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'BB',
    code3: 'BRB',
    name: 'バルバドス',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'BD',
    code3: 'BGD',
    name: 'バングラデシュ',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'BH',
    code3: 'BHR',
    name: 'バーレーン',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'PK',
    code3: 'PAK',
    name: 'パキスタン',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'PA',
    code3: 'PAN',
    name: 'パナマ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'PG',
    code3: 'PNG',
    name: 'パプアニューギニア',
    area_code: 'oce',
    flag: 1,
    display: null,
  },
  {
    code: 'PW',
    code3: 'PLW',
    name: 'パラオ',
    area_code: 'mic',
    flag: 1,
    display: 3,
  },
  {
    code: 'PY',
    code3: 'PRY',
    name: 'パラグアイ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'FJ',
    code3: 'FJI',
    name: 'フィジー',
    area_code: 'oce',
    flag: 1,
    display: 3,
  },
  {
    code: 'PH',
    code3: 'PHL',
    name: 'フィリピン',
    area_code: 'asi',
    flag: 1,
    display: 8,
  },
  {
    code: 'FI',
    code3: 'FIN',
    name: 'フィンランド',
    area_code: 'eur',
    flag: 1,
    display: 10,
  },
  {
    code: 'FR',
    code3: 'FRA',
    name: 'フランス',
    area_code: 'eur',
    flag: 1,
    display: 2,
  },
  {
    code: 'GF',
    code3: 'GUF',
    name: 'フランス領ギアナ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'PF',
    code3: 'PYF',
    name: 'フランス領ポリネシア（タヒチ）',
    area_code: 'oce',
    flag: 1,
    display: 4,
  },
  {
    code: 'BR',
    code3: 'BRA',
    name: 'ブラジル',
    area_code: 'sam',
    flag: 1,
    display: 4,
  },
  {
    code: 'BG',
    code3: 'BGR',
    name: 'ブルガリア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'BF',
    code3: 'BFA',
    name: 'ブルキナファソ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'BN',
    code3: 'BRN',
    name: 'ブルネイ',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'BT',
    code3: 'BTN',
    name: 'ブータン',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'PR',
    code3: 'PRI',
    name: 'プエルトリコ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'VN',
    code3: 'VNM',
    name: 'ベトナム',
    area_code: 'asi',
    flag: 1,
    display: 12,
  },
  {
    code: 'BJ',
    code3: 'BEN',
    name: 'ベナン',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'VE',
    code3: 'VEN',
    name: 'ベネズエラ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'BY',
    code3: 'BLR',
    name: 'ベラルーシ',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'BZ',
    code3: 'BLZ',
    name: 'ベリーズ',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'BE',
    code3: 'BEL',
    name: 'ベルギー',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'PE',
    code3: 'PER',
    name: 'ペルー',
    area_code: 'sam',
    flag: 1,
    display: 5,
  },
  {
    code: 'HN',
    code3: 'HND',
    name: 'ホンジュラス',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'BA',
    code3: 'BIH',
    name: 'ボスニア・ヘルツェゴビナ',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'BW',
    code3: 'BWA',
    name: 'ボツワナ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'BO',
    code3: 'BOL',
    name: 'ボリビア',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'PT',
    code3: 'PRT',
    name: 'ポルトガル',
    area_code: 'eur',
    flag: 1,
    display: 9,
  },
  {
    code: 'PL',
    code3: 'POL',
    name: 'ポーランド',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'MK',
    code3: 'MKD',
    name: 'マケドニア共和国',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'MG',
    code3: 'MDG',
    name: 'マダガスカル',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'MW',
    code3: 'MWI',
    name: 'マラウイ',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'MT',
    code3: 'MLT',
    name: 'マルタ',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'MQ',
    code3: 'MTQ',
    name: 'マルチニーク島',
    area_code: 'sam',
    flag: 1,
    display: null,
  },
  {
    code: 'MY',
    code3: 'MYS',
    name: 'マレーシア',
    area_code: 'asi',
    flag: 1,
    display: 11,
  },
  {
    code: 'MH',
    code3: 'MHL',
    name: 'マーシャル諸島',
    area_code: 'mic',
    flag: 1,
    display: null,
  },
  {
    code: 'FM',
    code3: 'FSM',
    name: 'ミクロネシア連邦',
    area_code: 'mic',
    flag: 1,
    display: null,
  },
  {
    code: 'MM',
    code3: 'MMR',
    name: 'ミャンマー',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'MX',
    code3: 'MEX',
    name: 'メキシコ',
    area_code: 'sam',
    flag: 1,
    display: 1,
  },
  {
    code: 'MZ',
    code3: 'MOZ',
    name: 'モザンビーク',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'MV',
    code3: 'MDV',
    name: 'モルディブ',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'MD',
    code3: 'MDA',
    name: 'モルドバ',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'MA',
    code3: 'MAR',
    name: 'モロッコ',
    area_code: 'afr',
    flag: 1,
    display: 4,
  },
  {
    code: 'MN',
    code3: 'MNG',
    name: 'モンゴル',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'ME',
    code3: 'MNE',
    name: 'モンテネグロ',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'MU',
    code3: 'MUS',
    name: 'モーリシャス',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'JO',
    code3: 'JOR',
    name: 'ヨルダン',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'LA',
    code3: 'LAO',
    name: 'ラオス',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'LV',
    code3: 'LVA',
    name: 'ラトビア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'LT',
    code3: 'LTU',
    name: 'リトアニア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'LR',
    code3: 'LBR',
    name: 'リベリア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'LU',
    code3: 'LUX',
    name: 'ルクセンブルク',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'RO',
    code3: 'ROU',
    name: 'ルーマニア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'LS',
    code3: 'LSO',
    name: 'レソト',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'LB',
    code3: 'LBN',
    name: 'レバノン',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'RE',
    code3: 'REU',
    name: 'レユニオン',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'RU',
    code3: 'RUS',
    name: 'ロシア',
    area_code: 'eur',
    flag: 1,
    display: null,
  },
  {
    code: 'CN',
    code3: 'CHN',
    name: '中華人民共和国（中国）',
    area_code: 'asi',
    flag: 1,
    display: 4,
  },
  {
    code: 'MP',
    code3: 'MNP',
    name: '北マリアナ諸島（サイパン）',
    area_code: 'mic',
    flag: 1,
    display: 2,
  },
  {
    code: 'ZA',
    code3: 'ZAF',
    name: '南アフリカ',
    area_code: 'afr',
    flag: 1,
    display: 5,
  },
  {
    code: 'TW',
    code3: 'TWN',
    name: '台湾',
    area_code: 'asi',
    flag: 1,
    display: 3,
  },
  {
    code: 'KR',
    code3: 'KOR',
    name: '大韓民国(韓国）',
    area_code: 'asi',
    flag: 1,
    display: 2,
  },
  {
    code: 'TL',
    code3: 'TLS',
    name: '東ティモール',
    area_code: 'asi',
    flag: 1,
    display: null,
  },
  {
    code: 'GQ',
    code3: 'GNQ',
    name: '赤道ギニア',
    area_code: 'afr',
    flag: 1,
    display: null,
  },
  {
    code: 'HK',
    code3: 'HKG',
    name: '香港・マカオ',
    area_code: 'asi',
    flag: 1,
    display: 5,
  },
]

export default countryCode
